import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=23a44917&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
import style0 from "./icon.vue?vue&type=style&index=0&id=23a44917&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a44917",
  null
  
)

export default component.exports